import useFiltersVariables from "components/Filters/useFiltersVariables";

import { INITIAL_SORT_OPTION, INITIAL_SORT_DIRECTION, FILTER_TYPE } from "./constants";

const useIntentProjectsFiltersVariables = () => {
  const { filterVariables, filterVariablesLoaded } = useFiltersVariables({
    filterType: FILTER_TYPE,
    initialSortDirection: INITIAL_SORT_DIRECTION,
    initialSortOption: INITIAL_SORT_OPTION,
  });

  return {
    fullTextSearch: filterVariables.searchInput,
    predicates: filterVariables.predicates,
    filterVariablesLoaded,
    sortOptionFields: filterVariables.sortOptionFields,
  };
};

export default useIntentProjectsFiltersVariables;
